// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__iI0PW","error":"Textarea_error__1Mcz2","borderless":"Textarea_borderless__tSpSj"};